<template>
  <div class="m-portlet m-portlet--mobile">
    <div class="m-portlet__body">
      <form :data-vv-scope="`authorization${idx}`">
        <div class="form-group m-form__group row">
          <div :class="[{'has-danger': errors.has(`authorization${idx}.identification_number_${idx}`)}, 'col-lg-3']">
            <label :for="`identification_number_${idx}`">{{'identification_number' | translate | capitalize }}</label>
            <input type="text" data-vv-as="identification_number" :id="`identification_number_${idx}`" v-model="auto.identification_number" :name="`identification_number_${idx}`" :placeholder="'enter_identification_number' | translate | capitalize" class="form-control m-input" v-validate="'required|alpha_num|min:4|max:15'" :readonly="edit" @keyup="uniqueIdentificationNumber(auto.identification_number, idx)">
            <span v-show="errors.has(`authorization${idx}.identification_number_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('identification_number',errors.first(`authorization${idx}.identification_number_${idx}`))}} </span>
          </div>
          <div class="col-lg-3" :class="{'has-danger': errors.has(`authorization${idx}.identification_type_${idx}`)}">
            <label :for="`identification_type_${idx}`">{{ 'identification_type' | translate | capitalize }}</label>
            <select data-vv-as="identification_type" :id="`identification_type_${idx}`" v-model="auto.identification_type" v-validate="'required'" :name="`identification_type_${idx}`" :class="{'form-control': true, 'error': errors.has(`identification_type_${idx}`) } ">
              <option value="">
                {{ 'select_an_option' | translate | capitalize }}
              </option>
              <option v-for="identification in identification_types" :value="identification.id" :key="identification.id">
                {{ identification.name }}
              </option>
            </select>
            <span v-show="errors.has(`authorization${idx}.identification_type_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('identification_type',errors.first(`authorization${idx}.identification_type_${idx}`))}} </span>
          </div>
          <div :class="[{'has-danger': errors.has(`authorization${idx}.first_name_${idx}`)}, 'col-lg-3']">
            <label :for="`first_name_${idx}`">{{'first_name' | translate | capitalize }}</label>
            <input data-vv-as="first_name" type="text" :id="`first_name_${idx}`" v-model="auto.first_name" :name="`first_name_${idx}`" :placeholder="'enter_first_name' | translate | capitalize" class="form-control m-input" v-validate="'required|alpha_spaces|min:2|max:50'">
            <span v-show="errors.has(`authorization${idx}.first_name_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('first_name', errors.first(`authorization${idx}.first_name_${idx}`))}} </span>
          </div>
          <div :class="[{'has-danger': errors.has(`authorization${idx}.last_name_${idx}`)}, 'col-lg-3']">
            <label :for="`last_name_${idx}`">{{'last_name' | translate | capitalize }}</label>
            <input data-vv-as="last_name" type="text" :id="`last_name_${idx}`" v-model="auto.last_name" :name="`last_name_${idx}`" :placeholder="'enter_last_name' | translate | capitalize" class="form-control m-input" v-validate="'required|alpha_spaces|min:2|max:50'">
            <span v-show="errors.has(`authorization${idx}.last_name_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('last_name', errors.first(`authorization${idx}.last_name_${idx}`))}} </span>
          </div>
        </div>
        <div class="form-group m-form__group row" v-if="is_cayena === 'true' && authorized_type_id === 1">
          <div class="col-lg-3" :class="{'has-danger': errors.has(`authorization${idx}.genre_${idx}`)}">
            <label :for="`genre_${idx}`">{{ 'genre' | translate | capitalize }}</label>
            <select data-vv-as="genre" :id="`genre_${idx}`" v-model="auto.genre" v-validate="'required'" :name="`genre_${idx}`" :class="{'form-control': true, 'error': errors.has(`genre_${idx}`) } ">
              <option value="">
                {{ 'select_an_option' | translate | capitalize }}
              </option>
              <option v-for="(option,index) in genres" :key="index" :value="option.name">
                {{ option.name }}
              </option>
            </select>
            <span v-show="errors.has(`authorization${idx}.genre_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('identification_type',errors.first(`authorization${idx}.genre_${idx}`))}} </span>
          </div>
          <div class="col-lg-3" :class="{'has-danger': errors.has(`authorization${idx}.blood_type_${idx}`)}">
            <label :for="`blood_type_${idx}`">{{ 'blood_type' | translate | capitalize }}</label>
            <select data-vv-as="blood_type" :id="`blood_type_${idx}`" v-model="auto.blood_type" v-validate="'required'" :name="`blood_type_${idx}`" :class="{'form-control': true, 'error': errors.has(`blood_type_${idx}`) } ">
              <option value="">
                {{ 'select_an_option' | translate | capitalize }}
              </option>
              <option v-for="(option,index) in blood_types" :key="index" :value="option.name">
                {{ option.name }}
              </option>
            </select>
            <span v-show="errors.has(`authorization${idx}.blood_type_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('blood_type',errors.first(`authorization${idx}.blood_type_${idx}`))}} </span>
          </div>
          <div :class="[{'has-danger': errors.has(`authorization${idx}.address_${idx}`)}, 'col-lg-3']">
            <label :for="`address_${idx}`">{{'address' | translate | capitalize }}</label>
            <input data-vv-as="address" type="text" :id="`address_${idx}`" v-model="auto.address" :name="`address_${idx}`" :placeholder="'enter_address' | translate | capitalize" class="form-control m-input" v-validate="'required|min:2|max:50'">
            <span v-show="errors.has(`authorization${idx}.address_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('address', errors.first(`authorization${idx}.address_${idx}`))}} </span>
          </div>
          <div :class="[{'has-danger': errors.has(`authorization${idx}.neighborhood_${idx}`)}, 'col-lg-3']">
            <label :for="`neighborhood_${idx}`">{{'neighborhood' | translate | capitalize }}</label>
            <input data-vv-as="neighborhood" type="text" :id="`neighborhood_${idx}`" v-model="auto.neighborhood" :name="`neighborhood_${idx}`" :placeholder="'enter_neighborhood' | translate | capitalize" class="form-control m-input" v-validate="'required|min:2|max:50'">
            <span v-show="errors.has(`authorization${idx}.neighborhood_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('last_name', errors.first(`authorization${idx}.neighborhood_${idx}`))}} </span>
          </div>
        </div>
        <div class="form-group m-form___group row">
          <div v-show="!group_register" :class="[{'has-danger': errors.has(`authorization${idx}.start_date_${idx}`)}, 'col-lg-3']">
            <label :for="`start_date_${idx}`">{{'start_date' | translate | capitalize }}</label>
            <s-date-time-picker :id="`start_date_${idx}`" data-vv-as="start_date" :name="`start_date_${idx}`" v-model="auto.start_date" :options="config.start" :placeholder="'AAAA-MM-DD'" v-validate="'required'" @empty="auto.start_date = $event" @input="startDate(idx, auto.start_date)"></s-date-time-picker>
            <span v-show="errors.has(`authorization${idx}.start_date_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('start_date',errors.first(`authorization${idx}.start_date_${idx}`))}}</span>
          </div>
          <div v-show="!group_register && authorized_type_id === 1" class="col-lg-3">
            <div class="m-checkbox-inline m-checkbox-inline-form-wizard">
              <label class="m-checkbox checkbox-form-wizard">
                {{ 'undefined_date' | capitalize }}
                <input type="checkbox" name="undefined" v-model="auto.undefined_date">
                <span></span>
              </label>
            </div>
          </div>
          <div v-show="!group_register && !auto.undefined_date" :class="[{'has-danger': errors.has(`authorization${idx}.end_date_${idx}`)}, 'col-lg-3']">
            <label :for="`end_date_${idx}`">{{'end_date' | translate | capitalize }}</label>
            <s-date-time-picker :id="`end_date_${idx}`" :name="`end_date_${idx}`"  data-vv-as="end_date" v-model="auto.end_date" :options="config.end" :placeholder="'AAAA-MM-DD'" v-validate="'required'" @empty="auto.end_date = $event" @input="endDate(idx, auto.end_date)"></s-date-time-picker>
            <span v-show="errors.has(`authorization${idx}.end_date_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('end_date',errors.first(`authorization${idx}.end_date_${idx}`))}} </span>
          </div>
          <div :class="[{'has-danger': errors.has(`authorization${idx}.email_${idx}`)}, 'col-lg-3']">
            <label :for="`email_${idx}`">{{'email' | translate | capitalize }}</label>
            <input data-vv-as="email" class="form-control m-input" type="text" :id="`email_${idx}`" v-model="auto.email" @blur="userAlreadyExist()" :name="`email_${idx}`" v-validate="auto.is_operator ? 'required|email||max:100|uniqueEmail' : auto.biometric ? 'required|email||max:100|uniqueEmail' : 'email||max:100|uniqueEmail'" :placeholder="'enter_email' | translate | capitalize">
            <span v-show="errors.has(`authorization${idx}.email_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('email',errors.first(`authorization${idx}.email_${idx}`))}} </span>
          </div>
          <div :class="[{'has-danger': errors.has(`authorization${idx}.company_origin_${idx}`)}, 'col-lg-3']" v-if="(authorized_type_id === 1 && is_cayena ==='true') || (authorized_type_id !== 1 && is_cayena ==='true')">
            <label :for="`company_origin_${idx}`">{{'company_origin' | translate | capitalize }}</label>
            <input data-vv-as="company_origin" class="form-control m-input" type="text" :id="`company_origin_${idx}`" v-model="auto.company_origin" :name="`company_origin_${idx}`" v-validate=" authorized_type_id === 3 ? 'min:2|max:100' : 'min:2|max:100|required'" :placeholder="'enter_company_origin' | translate | capitalize">
            <span v-show="errors.has(`authorization${idx}.company_origin_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('company_origin',errors.first(`authorization${idx}.company_origin_${idx}`))}} </span>
          </div>
          <div v-if="(is_cayena === 'true' && authorized_type_id === 1 )" :class="[{'has-danger': errors.has(`authorization${idx}.position_${idx}`)}, 'col-lg-3']">
            <label :for="`position_${idx}`">{{'position' | translate | capitalize }}</label>
            <input data-vv-as="position" class="form-control m-input" type="text" :id="`position_${idx}`" v-model="auto.position" :name="`position_${idx}`" v-validate="'required|alpha_spaces|min:5|max:50'" :placeholder="'enter_position' | translate | capitalize" :readonly="edit && auto.position !== ''">
            <span v-show="errors.has(`authorization${idx}.position_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('position',errors.first(`authorization${idx}.position_${idx}`))}} </span>
          </div>
          <div :class="[{'has-danger': errors.has(`authorization${idx}.observations_${idx}`)}, 'col-lg-6']">
            <label :for="`observations_${idx}`">{{'observations' | translate | capitalize }}</label>
            <textarea data-vv-as="observations" class="form-control m-input" :id="`observations_${idx}`" v-model="auto.observations" :name="`observations_${idx}`" v-validate="'alpha_spaces|min:5|max:200'" :placeholder="'enter_observation' | translate | capitalize">
            </textarea>
            <span v-show="errors.has(`authorization${idx}.observations_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('observations',errors.first(`authorization${idx}.observations_${idx}`))}} </span>
          </div>
          <div class="col-lg-3">
            <label>&nbsp;</label><br>
            <a v-if="!is_cargo" href="" v-tooltip="messageCarTooltip" :class="[{'btn-primary': !carsErrors},{'btn-danger': carsErrors},'buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill']" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#add_cars_modal" @click="addCar(idx)">
              <i class="fa fa-car"></i>
              <span v-if="auto.own_cars.length > 0" class="badge badge-notification">{{auto.own_cars.length}}</span>
            </a>
            <a v-else href="" v-tooltip="messageTruckTooltip" :class="[{'btn-primary': !cargoCarsErrors},{'btn-danger': cargoCarsErrors},'buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill']" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#add_cargo_cars_modal">
              <i class="fa fa-truck"></i>
              <span v-if="auto.cargo_cars.length > 0" class="badge badge-notification">{{auto.cargo_cars.length}}</span>
            </a>
            <label>&nbsp;</label>
            <!-- credencials -->
            <a v-if="shard.allow_credentials_assigned === 1" href="" v-tooltip="messageCredentialTooltip" :class="[{'btn-primary': !credentialErrors},{'btn-danger': credentialErrors},'buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill']" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#add_credentials_modal" @click="addCredential(idx)">
              <i class="fa fa-address-card"></i>
              <span v-if="auto.authorized_credentials.length > 0" class="badge badge-notification">{{auto.authorized_credentials.length}}</span>
            </a>
            <label v-if="showExpirations && !auto.undefined_date && !showIsUndefined">&nbsp;</label>
            <a v-if="showExpirations && !auto.undefined_date && !showIsUndefined"  href="" v-tooltip="messageDocumentTooltip" :class="[{'btn-primary': !expirationErrors},{'btn-danger': expirationErrors},'buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill']" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#add_expiration_modal" @click="addExpiration(idx)">
              <i class="fa fa-calendar-times-o"></i>
              <span v-if="auto.doc_types.length > 0" class="badge badge-notification">{{auto.doc_types.length}}</span>
            </a>
            <label v-if="is_photo_auth==='true'">&nbsp;</label>
            <a href="" v-if="is_photo_auth==='true'" v-tooltip="messageImageTooltip" :class="[{'btn-primary': !expirationErrors},{'btn-danger': expirationErrors},'buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill']" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#add_picture_modal">
              <i class="fa fa-camera"></i>
              <span v-if="auto.images.length > 0" class="badge badge-notification">{{auto.images.length}}</span>
            </a>
          </div>
          <div v-show="(showAccessProfile === '-1' && !groupRegister && showNumAutho === 1) || (showAccessProfile === '-1' && !groupRegister && showNumAutho > 1)" class="col-lg-3">
          <!--<div v-show="(showAccessProfile === '-1' && !group_register && showNumAutho === 1)" class="col-lg-3">  -->
            <label>&nbsp;</label><br>
            <a href="#" class="btn btn-success m-btn m-btn--icon m-btn--wide" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#access_profile_modal" @click.prevent="showAccessDayModal">
              <span>
                <i class="la la-calendar"></i>
                <span>{{ 'access_data' | capitalize }}</span>
              </span>
            </a>
          </div>
          <!-- <div v-show="(access_profile_id === '-1' && group_register === true)" class="col-lg-3">
            <label>&nbsp;</label><br>
            <a href="#" class="btn btn-success m-btn m-btn--icon m-btn--wide" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#access_profile_modal" @click.prevent="showAccessDayModal2">
              <span>
                <i class="la la-calendar"></i>
                <span>{{ 'access_data' | capitalize }}{{1}}</span>
              </span>
            </a>
          </div> -->
        </div>
        <div class="form-group m-form___group">
          <!--<details>-->
            <!-- <summary> {{'advanced_config' | translate | capitalize}} </summary> -->
            <div class="form-group m-form___group row details_container">
              <div :class="[{'has-danger': errors.has(`authorization${idx}.company_origin_${idx}`)}, 'col-lg-3']" v-if="(authorized_type_id !== 1 && is_cayena ==='false')">
                <label :for="`company_origin_${idx}`">{{'company_origin' | translate | capitalize }}</label>
                <input data-vv-as="company_origin" class="form-control m-input" type="text" :id="`company_origin_${idx}`" v-model="auto.company_origin" :name="`company_origin_${idx}`" v-validate="authorized_type_id === 2 ? 'min:2|max:100|required' : 'min:2|max:100'" :placeholder="'enter_company_origin' | translate | capitalize">
                <span v-show="errors.has(`authorization${idx}.company_origin_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('company_origin',errors.first(`authorization${idx}.company_origin_${idx}`))}} </span>
              </div>
            </div>
            <div class="form-group m-form___group row">
              <div v-if="showVisited" class="form-control checks col-lg-3">
                <div class="m-checkbox-list m-checkbox-inline-form-wizard">
                  <label class="m-checkbox">
                    <input type="checkbox" v-model="auto.is_responsible">
                    {{ 'is_responsible' | translate | capitalize }}
                    <span></span>
                  </label>
                </div>
              </div>
              <div v-if="showOperator" class="form-control checks col-lg-3" hidden>
                <div class="m-checkbox-list m-checkbox-inline-form-wizard">
                  <label class="m-checkbox">
                    <input type="checkbox" v-model="auto.is_operator">
                    {{ 'is_operator' | translate | capitalize }}
                    <span></span>
                  </label>
                </div>
              </div>
              <div v-if="showOwnFleet" class="form-control checks col-lg-3">
                <div class="m-checkbox-list m-checkbox-inline-form-wizard">
                  <label class="m-checkbox">
                    <input type="checkbox" v-model="auto.own_fleet">
                    {{ 'is_own_fleet' | translate | capitalize }}
                    <span></span>
                  </label>
                </div>
              </div>
              <div v-show="showBiometric == 'true'" class="form-control checks col-lg-3">
                <div class="m-checkbox-list m-checkbox-inline-form-wizard">
                  <label class="m-checkbox">
                    <input type="checkbox" v-model="auto.biometric" @click="checkBiometricsMail(auto.email)">
                    {{ 'biometric' | translate | capitalize }}
                    <span></span>
                  </label>
                </div>
              </div>
              <div v-if="isTraining && authorized_type_id !== 3 && authorized_type_id !== 4" class="form-control checks col-lg-3">
                <div class="m-checkbox-list m-checkbox-inline-form-wizard">
                  <label class="m-checkbox">
                    <input type="checkbox" v-model="auto.is_telecommuting">
                    {{ 'is_telecommuting' | translate | capitalize }}
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <label>&nbsp;</label><br>
              <a v-if="auto.own_fleet" href="" v-tooltip="messageOwnFleetCarTooltip" :class="[{'btn-primary': !carsErrors},{'btn-danger': carsErrors},'buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill']" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#add_ownfleet_cars_modal" @click="addCar(idx)">
                 <i class="fa fa-bus"></i>
                 <span v-if="own_fleet_vehicles_selected.length > 0" class="badge badge-notification">{{own_fleet_vehicles_selected.length}}</span>
              </a>
            </div>
            <div class="form-group m-form__group row container-hide">
              <!-- <div v-show="auto.is_responsible || auto.is_operator" :class="[{'has-danger': errors.has(`authorization${idx}.telephone_${idx}`)}, 'col-lg-3']">
                <label :for="`telephone_${idx}`">{{'telephone' | translate | capitalize }}</label>
                <input data-vv-as="telephone" class="form-control m-input" type="text" :id="`telephone_${idx}`" v-model="auto.telephone" :name="`telephone_${idx}`" v-validate="auto.is_responsible ? 'required|numeric|min:5|max:12' : ''" placeholder="0" :readonly="edit && auto.telephone !== ''">
                <span v-show="errors.has(`authorization${idx}.telephone_${idx}`)" class="m-form__help m--font-danger"> {{errors.first(`authorization${idx}.telephone_${idx}`)}} </span>
              </div>
              <div v-show="auto.is_responsible" :class="[{'has-danger': errors.has(`authorization${idx}.location_${idx}`)}, 'col-lg-3']">
                <label :for="`location_${idx}`">{{'location' | translate | capitalize }}</label>
                <input data-vv-as="location" class="form-control m-input" type="text" :id="`location_${idx}`" v-model="auto.location" :name="`location_${idx}`" v-validate="auto.is_responsible ? 'required|alpha_spaces|min:5|max:30' : ''" placeholder="enter location" :readonly="edit && auto.location !== ''">
                <span v-show="errors.has(`authorization${idx}.location_${idx}`)" class="m-form__help m--font-danger"> {{errors.first(`authorization${idx}.location_${idx}`)}} </span>
              </div> -->
              <div v-if="(auto.is_responsible && is_cayena === 'false')" :class="[{'has-danger': errors.has(`authorization${idx}.position_${idx}`)}, 'col-lg-3']">
                <label :for="`position_${idx}`">{{'position' | translate | capitalize }}</label>
                <input data-vv-as="position" class="form-control m-input" type="text" :id="`position_${idx}`" v-model="auto.position" :name="`position_${idx}`" v-validate="'alpha_spaces|min:5|max:30'" :placeholder="'enter_position' | translate | capitalize" :readonly="edit && auto.position !== ''">
                <span v-show="errors.has(`authorization${idx}.position_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('position',errors.first(`authorization${idx}.position_${idx}`))}} </span>
              </div>
              <div v-show="auto.is_operator" :class="[{'has-danger': errors.has(`authorization${idx}.profile_operator_${idx}`)}, 'col-lg-3']">
                <label :for="`profile_operator_${idx}`">{{'profile_operator' | translate | capitalize }}</label>
                <select data-vv-as="profile_operator" :id="`profile_operator_${idx}`" v-model="auto.profile_operator" v-validate="auto.is_operator ?'required' : ''" :name="`profile_operator_${idx}`" :class="{'form-control': true, 'error': errors.has(`authorization${idx}.profile_operator_${idx}`) } ">
                  <option value="">
                    {{ 'select_an_option' | translate | capitalize }}
                  </option>
                  <option v-for="profile in profiles" :value="profile.id" :key="profile.id">
                    {{ profile.name }}
                  </option>
                </select>
                <span v-show="errors.has(`authorization${idx}.profile_operator_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('profile_operator',errors.first(`authorization${idx}.profile_operator_${idx}`))}} </span>
              </div>
            </div>
          <!-- </details> -->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
// import axios from 'axios'
import { Validator } from 'vee-validate'
import service from '@/services/superaccess'
export default {
  props: ['idx', 'auto', 'is_undefined', 'group_register', 'identification_types', 'profiles', 'tab_validator', 'edit', 'access_profile_id', 'authorized_types', 'authorized_type_id', 'department_type_id', 'access_day_view', 'access_day', 'num_authorized', 'hide_department', 'visited_to', 'document_reception', 'is_cargo', 'access_credentials', 'is_reception', 'isTraining', 'is_cayena', 'require_facility', 'images', 'is_photo_auth', 'own_fleet_vehicles', 'own_fleet_vehicles_selected'],
  inject: {
    $validator: '$validator'
  },
  data () {
    return {
      start_date: '',
      end_date: '',
      config: {
        start: {
          format: 'yyyy-mm-dd',
          minView: 2,
          startDate: moment().format('YYYY-MM-DD'),
          autoclose: true,
          pickerPosition: 'bottom-left'
        },
        end: {
          format: 'yyyy-mm-dd',
          minView: 2,
          startDate: moment().format('YYYY-MM-DD'),
          autoclose: true,
          pickerPosition: 'bottom-left'
        }
      },
      access_profile: {},
      validate_email: true,
      showBiometric: false,
      messageCarTooltip: this.$options.filters.capitalize('add_vehicles'),
      messageOwnFleetCarTooltip: this.$options.filters.capitalize('add_own_fleet_vehicles'),
      messageTruckTooltip: this.$options.filters.capitalize('add_truck_vehicles'),
      messageCredentialTooltip: this.$options.filters.capitalize('add_credentials_value'),
      messageDocumentTooltip: this.$options.filters.capitalize('add_documents_expiration'),
      messageImageTooltip: this.$options.filters.capitalize('add_image_auth'),
      genres: [
        {name: 'Masculino'},
        {name: 'Femenino'},
        {name: 'Otro'}
      ],
      blood_types: [
        {name: 'O+'},
        {name: 'O-'},
        {name: 'A+'},
        {name: 'A-'},
        {name: 'B+'},
        {name: 'B-'},
        {name: 'AB+'},
        {name: 'AB-'}
      ]
    }
  },
  created () {
    this.getStateBiometric({data: this.shard})
      .then((res) => {
        this.showBiometric = res.data.propConfig.value
      })
      .catch((err) => {
        this.$toast('An error has been ocurred')
        console.log(err)
      })
    // this.$validator.attach({ name: 'email_' + this.idx, rules: 'uniqueEmail|email|max:100' })
    // this.setValidateEmail(this.validate_email)
    // this.uniqueEmail()
    if (this.document_reception !== '') this.auto.identification_number = this.document_reception
  },
  computed: {
    ...mapGetters({clicked: 'getClicked', modal_access_day: 'getModalAccessDay', shard: 'getUserShard'}),
    showVisited () {
      if (this.authorized_types.length > 0) {
        const auth_type = this.authorized_types.find(auth => auth.id === this.authorized_type_id)
        return auth_type ? auth_type.is_responsible === 1 : false
      }
    },
    showOperator () {
      if (this.authorized_types.length > 0) {
        const auth_type = this.authorized_types.find(auth => auth.id === this.authorized_type_id)
        return auth_type ? auth_type.portal_operator === 1 : false
      }
    },
    showOwnFleet () {
      if (this.authorized_types.length > 0) {
        const auth_type = this.authorized_types.find(auth => auth.id === this.authorized_type_id)
        return auth_type ? auth_type.own_fleet === 1 : false
      }
    },
    cargoCarsErrors () {
      let result = false
      if (Object.keys(this.auto.cargo_cars).length > 0) {
        this.errors.items.forEach(er => {
          if (er.field.startsWith('truck_license_plate') || er.field.startsWith('cargo_vehicle_type') || er.field.startsWith('cargo_order') || er.field.startsWith('container_number')) result = true
        })
      }
      return result
    },
    carsErrors () {
      let result = false
      if (Object.keys(this.auto.own_cars).length > 0) {
        this.errors.items.forEach(er => {
          if (er.field.startsWith('plate')) result = true
        })
      }
      return result
    },
    expirationErrors () {
      let result = false
      if (this.errors.items.length > 0) {
        this.errors.items.forEach(er => {
          if (er.field.startsWith('expires_doc')) result = true
        })
      }
      return result
    },
    showIsUndefined () {
      const self = this
      let is_undefined = self.is_undefined
      return is_undefined
    },
    showNumAutho () {
      const self = this
      let num_authorized = self.num_authorized
      return num_authorized
    },
    showAccessProfile () {
      const self = this
      let access_profile_id = self.access_profile_id
      return access_profile_id
    },
    credentialErrors () {
      let result = false
      if (this.errors.items.length > 0) {
        this.errors.items.forEach(er => {
          if (er.field.startsWith('value_credential') || (this.require_facility === 'true' && er.field.startsWith('facility_code'))) result = true
        })
      }
      return result
    },
    groupRegister () {
      const self = this
      let group_register = self.group_register
      return group_register
    }
  },
  methods: {
    ...mapActions(['retrieveData', 'setStatusEditAccessDay', 'getStateBiometric', 'showAuthorization', 'showAuthorizationList']),
    ...mapMutations(['setClicked', 'setValidated', 'setIdxCar', 'setBlockade', 'setValidateEmail']),
    showExpirations () {
      const self = this
      let auth_type = this.authorized_types.find(auth => auth.id === self.authorized_type_id)
      return auth_type.documents.length > 0
    },
    uniqueEmail (email, identification) {
      // this.setValidateEmail(true)
      this.setValidateEmail(this.validate_email)
      if (email !== '' && identification !== undefined && email.trim().length > 0 && identification.trim().length > 0) {
        service.post('/api/person/check-email', this.$store, { email: email, identification_number: identification })
          .then((response) => {
            this.validate_email = response.data.valid
            this.setValidateEmail(response.data.valid)
          })
      }
      return this.validate_email
    },
    showAccessDayModal () {
      (this.visited_to !== '' && !this.hide_department) || (this.hide_department) ? this.$emit('showAccessDayModalChild') : this.$toast('fill_responsible', 3)
    },
    showAccessDayModal2 () {
      if (this.visited_to !== '') {
        this.$emit('showAccessDayModalChild')
      } else if (this.authorized_type_id === 3) {
        this.$toast('fill_responsible', 3)
      }
    },
    uniqueIdentificationNumber (value, key) {
      let result = true
      if (value.length > 6) {
        service.post('/api/person/check-identification-number', this.$store, { identification_number: value, id: this.auto.person_id ? this.auto.person_id : '' })
          .then((response) => {
            if (response.data.authorization.length > 0) {
              result = false
              this.$confirmation('attention', 'exist_authorization_with_document_number')
                .then((res) => {
                  if (res.value) {
                    service.post('/api/authorization/activate', this.$store, {
                      authorization_id: response.data.authorization[0].id
                    }).then((response) => {
                      this.$router.push('/admin/staff-register/edit/' + response.data.authorization.id)
                    })
                  }
                  this.userAlreadyExist()
                })
            } else {
              this.userAlreadyExist()
            }
            if (!response.data.valid && !response.data.blockade && result && response.data.find_user.length === 0) {
              result = false
              this.$confirmation('attention', 'confirm_identification_number_message')
                .then((res) => {
                  if (res.value) {
                    result = true
                    this.$spinner.show()
                    service.post('/api/person/show', this.$store, { identification_number: value })
                      .then((respon) => {
                        this.$spinner.remove()
                        this.auto.person_id = respon.data.id
                        this.auto.first_name = respon.data.first_name
                        this.auto.last_name = respon.data.last_name
                        this.auto.email = respon.data.email
                        this.auto.identification_type = respon.data.identification_type
                        if (this.is_cayena === 'true') {
                          this.auto.blood_type = respon.data.blood_type
                          this.auto.genre = respon.data.genre
                          this.auto.address = respon.data.address
                          this.auto.neighborhood = respon.data.neighborhood
                          this.auto.position = respon.data.position
                        }
                        if (this.is_photo_auth === 'true') {
                          this.showAuthorizationList(this.auto.identification_number)
                            .then((response) => {
                              this.showAuthorization(response.data.data[0].id)
                                .then((img) => {
                                  this.img = img.data.authorization.images.file
                                  this.auto.images.file = img.data.authorization.images.file
                                  this.auto.images.value = img.data.authorization.images.value ? respon.data.authorization.images.value : 'demo.png'
                                })
                                .catch((err) => {
                                  console.log(err)
                                })
                            })
                            .catch((err) => {
                              console.log(err)
                            })
                        }
                        this.userAlreadyExist()
                      })
                      .catch((err) => {
                        console.log(err)
                      })
                  } else {
                    this.userAlreadyExist()
                  }
                })
                .catch((err) => {
                  console.log(err)
                  result = true
                })
            }
            if (response.data.valid && !response.data.blockade && response.data.find_user.length > 0 && result && response.data.authorization.length === 0) {
              result = false
              this.$confirmation('attention', 'confirm_identification_number_message')
                .then((res) => {
                  if (res.value) {
                    result = true
                    this.$spinner.show()
                    this.auto.first_name = response.data.find_user[0].first_name
                    this.auto.last_name = response.data.find_user[0].last_name
                    this.auto.email = response.data.find_user[0].email
                    this.auto.identification_type = response.data.find_user[0].identification_type.id
                    this.userAlreadyExist()
                    this.$spinner.remove()
                  } else {
                    this.userAlreadyExist()
                  }
                })
                .catch((err) => {
                  console.log(err)
                  result = true
                })
            } else {
              if (response.data.blockade) {
                this.setBlockade(true)
                swal({
                  type: 'warning',
                  title: this.$options.filters.capitalize('people_already_blockade'),
                  showConfirmButton: false,
                  timer: 5000
                })
              }
            }
          })
      }
    },
    startDate (k, value) {
      this.$set(this.config.end, 'startDate', value)
      if (this.auto.start_date.replace(':', '') > this.auto.end_date.replace(':', '')) {
        this.auto.end_date = this.auto.start_date
        this.$root.$emit('date_expiration', this.auto.end_date)
      }
    },
    endDate (k, value) {
      this.$root.$emit('date_expiration', value)
    },
    addCar (idx) {
      this.auto.own_cars.length === 0 ? this.auto.own_cars.push({ license_plate: '', type_vehicle: '' }) : ''
      this.setIdxCar(idx)
    },
    addExpiration (idx) {
      if (this.auto.doc_types.length !== 0) {
        this.auto.doc_types.length === 0 ? this.auto.doc_types.push({ doc_types: 0, value: '', idx: 0 }) : ''
        this.setIdxCar(idx)
      }
    },
    addCredential (idx) {
      if (this.access_credentials.length !== 0) {
        this.auto.authorized_credentials.length === 0 ? this.auto.authorized_credentials.push({ credential_id: 0, value: '', idx: 0 }) : ''
        this.setIdxCar(idx)
      }
    },
    checkBiometricsMail (mail) {
      if (mail === '') {
        this.$toast('biometrics_mail_required', 2)
      }
    },
    translateErrorMessage (key, errorMessage) {
      let message = ''
      if (errorMessage) {
        message = errorMessage.replace(key, this.$options.filters.capitalize(key))
      }
      // } else {
      //   message = errorMessage.replace(key, this.$options.filters.capitalize(key))
      // }
      return message
    },
    userAlreadyExist () {
      this.$validator.validateAll(`authorization${this.tab_validator}`)
        .then((res) => {
          this.setClicked(false)
          this.setValidated(res)
        })
      this.setValidateEmail(this.validate_email)
      Validator.extend('uniqueEmail', {
        getMessage: field => {
          return this.$options.filters.capitalize('email_already_exists2')
        },
        // Returns a boolean value
        validate: value => {
          return this.uniqueEmail(this.auto.email, this.auto.identification_number)
        }
      })
    }
  },
  mounted () {
    this.$root.$on('change_authorized', (authorized_type_id) => {
      let type_authorized = authorized_type_id
      if (type_authorized !== 1) {
        this.auto.undefined_date = false
        this.auto.own_fleet = false
        this.auto.is_responsible = false
        this.auto.telephone = 0
        this.auto.location = ''
        this.auto.position = ''
        this.auto.genre = ''
        this.auto.blood_type = ''
      }
    })
    this.auto.genre = ''
    this.auto.blood_type = ''
  },
  watch: {
    clicked (newVal, oldVal) {
      if (newVal === true && oldVal === false) {
        this.$validator.validateAll(`authorization${this.tab_validator}`)
          .then((res) => {
            this.setClicked(false)
            this.setValidated(res)
          })
      }
    },
    // authorized_type_id (newVal, oldVal) {
    //   if (newVal !== 1) {
    //     this.auto.is_responsible = false
    //     this.auto.telephone = 0
    //     this.auto.location = ''
    //     this.auto.position = ''
    //   }
    // },
    document_reception () {
      if (this.document_reception !== '') this.auto.identification_number = this.document_reception
    },
    validate_email (newVal, oldVal) {
      this.$validator.validate().then(result => {})
    }
  }
}
</script>

<style scoped>
.details_container {
  padding-top: 15px
}
.checks {
  border: 0 !important;
}
div.m-checkbox-inline-form-wizard {
  margin: 10px 0 10px 0 !important;
}
.checkbox-form-wizard {
  margin: 15px !important;
}
.badge-notification {
  border-radius: 60px;
  background-color: #D73925;
}
</style>



// WEBPACK FOOTER //
// FormContent.vue